import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from 'src/components/ui/Badge/Badge';
import { InvoiceStatus } from 'src/services/invoices';
import { STATUS_BADGE } from './invoiceFormat';

const InvoiceStatusBadge: React.FC<{ status: InvoiceStatus }> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Badge
      className="max-w-min normal-case"
      label={t(`invoices.status.${status}`)}
      expanded
      type={STATUS_BADGE[status]}
    />
  );
};

export default InvoiceStatusBadge;
